import { render, staticRenderFns } from "./agreeToReturn.vue?vue&type=template&id=814da84e&scoped=true"
import script from "./agreeToReturn.vue?vue&type=script&lang=js"
export * from "./agreeToReturn.vue?vue&type=script&lang=js"
import style0 from "./agreeToReturn.vue?vue&type=style&index=0&id=814da84e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814da84e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城商家端\\fhj-web-dyh-mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('814da84e')) {
      api.createRecord('814da84e', component.options)
    } else {
      api.reload('814da84e', component.options)
    }
    module.hot.accept("./agreeToReturn.vue?vue&type=template&id=814da84e&scoped=true", function () {
      api.rerender('814da84e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/agreeToReturn.vue"
export default component.exports